export const profile = {
  name: 'Kadir Aslan',
  summary:
    'Creative developer with a passion for building elegant solutions to complex challenges. I enjoy exploring new technologies, doing research, and pushing the boundaries of computer science through clean, efficient code.',
  bio: [
    'I am a frontend-leaning full-stack developer who likes turning fuzzy ideas into products people actually enjoy using.',
    'My background spans web apps, search and data tooling, and some machine learning. Whatever the stack, I care about clean code, thoughtful interfaces, and shipping.',
  ],
  contact: {
    email: 'kdr.aslan@hotmail.com',
    phone: '+491717095789',
    location: 'Munich, Germany',
  },
};

export const experience = [
  {
    role: 'Frontend Developer',
    org: 'CHECK24',
    period: '2023 - Present',
    note: 'Building and shipping production features for large-scale web apps used by thousands of customers and agents.',
  },
  {
    role: 'Working Student',
    org: 'Siemens',
    period: '2020 - 2023',
    note: 'Built internal search, analytics and data-visualization tools for large-scale systems.',
  },
  {
    role: 'Software Intern',
    org: 'Webmag',
    period: '2020',
    note: 'Built themeable, reusable UI components and a small framework for a publishing platform.',
  },
  {
    role: 'Android Intern',
    org: 'Sociable',
    period: '2019',
    note: 'Built a cross-platform mobile game with its own physics engine.',
  },
];

export const education = [
  {
    school: 'Technical University of Munich',
    degree: 'M.Sc. in Informatics',
    detail: 'Grade 1.9 (3.4 GPA)',
    period: '2019 - 2021',
    note: 'Focused on machine learning and data analytics, with a thesis in control theory.',
  },
  {
    school: 'Boğaziçi University',
    degree: 'B.Sc. in Computer Engineering',
    detail: 'GPA 3.1',
    period: '2013 - 2019',
    note: 'A broad foundation across computer hardware, software and theory.',
  },
];

export const interests = ['Oil Painting', 'Calligraphy', 'Digital Illustration'];
